import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'
import { getTempCouponById, getTempCouponDetailImageFile } from '../List/useModel'

const TempCouponDetail = () => {
  const { i18n } = useTranslation()
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const language = i18n.language

  const store = useMemo(() => getTempCouponById(id), [id])

  if (!store) {
    return (
      <div className="flex min-h-[calc(100vh-var(--spacing)*45)] flex-col items-center justify-center gap-6 bg-[#FAFAFA] px-6 py-16">
        <LangText lngKey="coupon.detail.notFound" className="text-center text-[16px] text-[#666666]" />
        <Link
          to="/coupon-list"
          className="text-[15px] font-medium text-[#5A5EFA] no-underline hover:opacity-80"
        >
          <LangText lngKey="coupon.detail.backToList" />
        </Link>
      </div>
    )
  }

  return (
    <div className="min-h-[calc(100vh-var(--spacing)*45)] bg-[#FAFAFA] py-[88px]">
      <div className="mx-auto w-[1200px]">
        <img
          src={preFixImgUrl(getTempCouponDetailImageFile(store, language))}
          alt=""
          className="object-contain w-full h-auto"
        />
      </div>
    </div>
  )
}

export default TempCouponDetail
